import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { TimerComponent } from './timer-component';

@NgModule({
  declarations: [TimerComponent],
  imports: [IonicPageModule.forChild(TimerComponentModule)],
  exports: [TimerComponent]
})
export class TimerComponentModule {}


// WEBPACK FOOTER //
// ./src/components/myria/timer-component/timer-component.module.ts